import { useState } from 'react'
import { supabase } from '@/lib/supabase'
import { useAuthStore } from '@/store/auth'
import { AuthLayout } from '@/components/gg/AuthLayout'

/**
 * The iPhone app never signs anyone up or runs setup (Brian: onboarding
 * happens on the website). An account that has not finished setting up gets
 * this instead: finish on the website, then come back and sign in.
 */
export function FinishOnWebsite() {
  const email = useAuthStore((s) => s.user?.email)
  const [busy, setBusy] = useState(false)
  return (
    <AuthLayout
      eyebrow="Almost there"
      title="Finish setting up on the website"
      lede={<>Your places, topics and voice are set up on a computer. Go to <b>gogrov.com</b>, sign in{email ? <> as <b>{email}</b></> : ''} and finish there. Then come back here to read your feed and record.</>}
      foot={<button type="button" className="auth2__link" disabled={busy}
        onClick={() => { setBusy(true); void supabase.auth.signOut().finally(() => setBusy(false)) }}>Sign out</button>}
    >
      <p className="auth2__lede">It takes about ten minutes. Nothing you do there needs doing again here.</p>
    </AuthLayout>
  )
}
